export default __webpack_public_path__ + "static/media/returned.69695381.svg";